import { IGetRowsParams, GridApi } from 'ag-grid-community';
import { lastValueFrom } from 'rxjs';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../Compliance/AgGrid';
import { TaxFeedLogRepository } from '../taxFeedLog.repository';

export class TaxFeedLogListAgGridDataSource extends AgGridDataSourceBase<void> {
    constructor(
        readonly gridApi: GridApi,
        private readonly _taxFeedLogRepository: TaxFeedLogRepository
    ) {
        super(gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Core.TaxFeedSummaryLogPropertyEnum>[] = [
        { name: 'taxFeedSummaryLogId', value: Core.TaxFeedSummaryLogPropertyEnum.TaxFeedSummaryLogId },
        { name: 'operationType', value: Core.TaxFeedSummaryLogPropertyEnum.OperationType },
        { name: 'startTime', value: Core.TaxFeedSummaryLogPropertyEnum.StartTime },
        { name: 'endTime', value: Core.TaxFeedSummaryLogPropertyEnum.EndTime },
        { name: 'requestPayloadJson', value: Core.TaxFeedSummaryLogPropertyEnum.RequestPayloadJson },
        { name: 'responsePayloadJson', value: Core.TaxFeedSummaryLogPropertyEnum.ResponsePayloadJson },
        { name: 'summaryIdsJson', value: Core.TaxFeedSummaryLogPropertyEnum.SummaryIdsJson }
    ];

    protected canGetRows(): boolean {
        return true;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Core.TaxFeedSummaryLogSearchModel = {
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap)
        };

        const result = await lastValueFrom(this._taxFeedLogRepository.getList(searchParams));

        return {
            rows: result.data,
            totalRows: result.totalRows
        } as AgGridDataSourceResult;
    }
}
